import { clsx } from "clsx";
import React, { useMemo } from "react";

import {
  FormSelectCustom,
  type FormSelectCustomProps,
  type FormSelectCustomOption,
} from "@bared/ui";

import type { ProductVariant } from "./route";

export interface VariantSelectorProps {
  /** Array of product variants from server */
  productVariants: Pick<ProductVariant, "id" | "status" | "label">[];
  /** Current selected variant ID */
  selectedVariantId: string | null;
  /** Called when a variant is selected  */
  onChange: (selectedVariantId: string) => void;
  /** Optional class for select */
  className?: string;
  /** Optional size for selector */
  size?: FormSelectCustomProps["size"];
}

export function VariantSelector({
  onChange,
  className,
  size = "lg",
  productVariants,
  selectedVariantId,
}: VariantSelectorProps) {
  const options = useMemo<FormSelectCustomOption[]>(
    () =>
      productVariants.map((productVariant) => ({
        id: productVariant.id,
        label: productVariant.label,
        isDisabled: "UNAVAILABLE" === productVariant.status,
        helpText:
          "LOW_STOCK" === productVariant.status
            ? "Low stock"
            : "UNAVAILABLE" === productVariant.status
              ? "Sold out"
              : "NOTIFY" === productVariant.status
                ? "Notify me"
                : "PRE_ORDER" === productVariant.status
                  ? "Pre-order"
                  : "FINAL_SALE" === productVariant.status
                    ? "Final sale"
                    : null,
      })),
    [],
  );

  return (
    <FormSelectCustom
      size={size}
      label="Size"
      options={options}
      onChange={onChange}
      placeholder="Select a size"
      value={selectedVariantId}
      // The "flex" here is so the button expands to the height.
      className={clsx("flex", className)}
    />
  );
}
